module.exports = __webpack_public_path__ + "roboto-v15-latin-regular.ttf";


//////////////////
// WEBPACK FOOTER
// ./~/primeng/resources/themes/omega/fonts/roboto-v15-latin-regular.ttf
// module id = 523
// module chunks = 321 325